import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './chatSidebar.scss';
import { t } from '../../services/i18nService';
import CloseSidebarButton from './CloseSidebarButton';
import sessionReader from '../../store/readHelpers/SessionReader';
import UIConstants, { contrastOptions } from '../../constants/UIConstants';
import chatIntegrationService from '../../services/ChatIntegrationService';

const ChatSidebarContainer = ({ contrastOption, zoomFactor }) => {
    const chatBoxHost = chatIntegrationService.getChatBoxHost();
    const iframeFormRef = useRef();

    useEffect(() => {
        iframeFormRef.current.submit();
    }, []);

    return (<div
        id="chat-sidebar"
        role="complementary"
        className={styles.sideBar}
    >
        <div
            className={styles.header}
            aria-label={t('chat.sidebarAriaLabelText')}
        >
            <div className={styles.titleContainer}>
                <span className={styles.title}>{t('chat.sidebarTitle')}</span>
            </div>

            <CloseSidebarButton />
        </div>

        <div className={styles.container}>
            <form action={chatBoxHost} ref={iframeFormRef} target="chat-iframe" method="post">
                <input type="hidden" name="token" value={chatIntegrationService.getToken()} />
                <input type="hidden" name="user_locale" value={sessionReader.getLanguage()} />
                <input type="hidden" name="color_options" value={contrastOption} />
                <input type="hidden" name="font_size" value={zoomFactor} />
                <input
                    type="hidden"
                    name="disable_cut_copy_paste"
                    value={sessionReader.shouldDisableCopyPasteInPlayerChatbox()}
                />
            </form>
            <iframe title={t('chat.chatBoxTitle')} name="chat-iframe" className={styles.chatContainer} />
        </div>
    </div>);
};

const mapStateToProps = ({ ui }) => {
    const {
        contrastOption = contrastOptions.NORMAL,
        zoomFactor = UIConstants.ZOOM_FACTOR.SMALL,
    } = ui;

    return {
        contrastOption,
        zoomFactor,
    };
};

ChatSidebarContainer.propTypes = {
    contrastOption: PropTypes.string.isRequired,
    zoomFactor: PropTypes.string.isRequired,
};

const ChatSidebar = connect(mapStateToProps)(ChatSidebarContainer);
export default ChatSidebar;
